import { useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useRouter } from "next/router";
import classnames from "classnames";
import { SearchInputField } from "./Parts/index";
import { useState } from "react";
import IconSearch from "../../../src/svgs/icon_search.svg";
import styles from "@/styles/Form.module.scss";
import { useDeviceInfoQuery } from "@/hooks";

export default function SearchFormSp({ onSubmit, ...props }) {
  const { register, handleSubmit, setValue, reset } = useForm();
  const [showSearchFormSp, setShowSearchFormSp] = useState(false);
  const router = useRouter();
  const searchQuery = router?.query?.q;
  const { data } = useDeviceInfoQuery({ fetchPolicy: "cache-first" });
  const deviceInfo = data?.deviceInfo;
  const handleKeyDown = useCallback(
    (e) => {
      // Return
      if (e.key === "Enter" && deviceInfo?.isMobile) {
        setTimeout(() => {
          e.target.blur();
        }, 200);
      }
    },
    [deviceInfo]
  );

  useEffect(() => {
    if (router.pathname === "/search" && searchQuery) {
      setValue("search", searchQuery);
    }
  }, [router.asPath, searchQuery]);

  useEffect(() => {
    const handleRouteChange = (url) => {
      if (!~url.indexOf("/search")) {
        reset({ search: "" });
      }
    };
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);

  return (
    <form
      action="#"
      onSubmit={handleSubmit(onSubmit)}
      className={classnames(styles.searchFormSp, {
        [styles.show]: showSearchFormSp,
      })}
      noValidate
    >
      <SearchInputField
        {...register("search")}
        onKeyDown={handleKeyDown}
        placeholder="サイト内検索"
        {...props}
      />
      <button type="submit" className={styles.searchFormSubmitBtn}>
        <IconSearch />
      </button>
      <button
        type="button"
        onClick={() => setShowSearchFormSp(false)}
        className={styles.searchFormCancelBtn}
      >
        キャンセル
      </button>
      <button
        onClick={() => setShowSearchFormSp((prevState) => !prevState)}
        type="button"
        className={styles.showSearchFormSpBtn}
      >
        <IconSearch />
      </button>
    </form>
  );
}
